import { render, staticRenderFns } from "./Complainttutor.vue?vue&type=template&id=93bbd1ba&"
import script from "./Complainttutor.vue?vue&type=script&lang=js&"
export * from "./Complainttutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports